import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css'; // Import the default styles

const Gallery = ({
  heading1 = 'Explore Our Industrial Machinery Gallery',
  items = [],
  showHeading = true,
}) => {
  // Format the items to suit `react-image-gallery` requirements
  const formattedItems = items.map((item) => {
    if (item.type === 'image') {
      const original = item.src;
      const thumbnail = item.thumbnail ? item.thumbnail : original;
      return {
        original,
        thumbnail,
        description: item.alt,
        type: 'image',
      };
    }
    if (item.type === 'video') {
      return {
        embed_id: item.embed_id, // Include embed_id for video
        description: item.alt,
        type: 'video',
      };
    }
    return null;
  });

  // Custom render function for `react-image-gallery`
  const renderItem = (item) => {
    if (item.type === 'video') {
      return (
        <div className="video-wrapper">
          <iframe
            width="100%"
            height="500"
            src={`https://www.youtube.com/embed/${item.embed_id}`}
            title={item.description}
          ></iframe>
        </div>
      );
    }
    return (
      <img
        src={item.original}
        alt={item.description}
        style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
      />
    );
  };

  return (
    <Container className="py-3">
      {/* Heading Section */}
      {showHeading && (
        <Row className="mb-4 text-center">
          <Col>
            <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem' }}>{heading1}</h2>
          </Col>
        </Row>
      )}

      {/* Image/Video Gallery Section */}
      <Row>
        <Col>
          <ImageGallery
            items={formattedItems}
            showPlayButton={false}
            renderItem={renderItem}
          />
        </Col>
      </Row>
    </Container>
  );
};

Gallery.propTypes = {
  heading1: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['image', 'video']).isRequired,
      src: PropTypes.string, // Required for images
      embed_id: PropTypes.string, // Required for videos
      alt: PropTypes.string.isRequired,
      thumbnail: PropTypes.string, // Optional thumbnail for images
    })
  ).isRequired,
  showHeading: PropTypes.bool,
};

export default Gallery;